import { getCurrentLanguage } from '@/config/i18n';
import { API_ENDPOINTS } from '@/constants/api';

/**
 * Builds the Gateway authorize URL, carrying the active UI language so the
 * Keycloak login/registration screen opens in the same language as the app.
 * The Gateway validates `locale` and forwards it to Keycloak as `ui_locales`.
 *
 * @param returnPath - In-app path (with query string) to return to after login.
 */
export function buildAuthorizeUrl(returnPath: string): string {
  const returnUrl = encodeURIComponent(returnPath);
  return `${API_ENDPOINTS.AUTH.AUTHORIZE}?returnUrl=${returnUrl}&locale=${getCurrentLanguage()}`;
}
